module.exports = __webpack_public_path__ + "img/title6_2.4b03711f.png";